import classNames from 'classnames';
import type { VoidFunctionComponent } from 'react';

type Props = {
  complete: boolean;
};

const CheckmarkCircleLoader: VoidFunctionComponent<Props> = ({ complete }) => (
  <div className={classNames({ 'circle-loader': true, 'circle-loader-complete': complete })}>
    <div className={classNames('circle-loader-checkmark draw', {
      'display-none': !complete,
    })} />
  </div>
);

export default CheckmarkCircleLoader;
